module.exports = __webpack_public_path__ + "img/blue_101.fbd849bb.png";